module.exports = __webpack_public_path__ + "static/img/hexinyewu.e28307d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/hexinyewu.png
// module id = 26IM
// module chunks = 44